export var HTTP_STATUS = {
    TOO_MANY_REQUEST: 429,
    LOOP_DETECTED: 508
};
